import { useLocation } from "@tanstack/react-router";
import { AnimatedSidebarProvider } from "@/components/ui/animated-sidebar";
import { useCampaignCreationTasks } from "@/hooks/use-campaign-creation-tasks";
import { cn } from "@/lib/utils";
import { AppSidebar } from "./app-sidebar";
import { AssistantLauncher } from "./assistant-launcher";
import { SiteHeader } from "./site-header";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function pageOwnsApplicationScroll(pathname: string, searchStr = ""): boolean {
  return (
    pathname === "/campaigns/new" ||
    pathname === "/campaigns/template-portfolio" ||
    (pathname === "/campaigns" &&
      ["smartCreation", "creationTask"].some((key) => new URLSearchParams(searchStr).has(key)))
  );
}

export function AppLayout({ children }: AppLayoutProps) {
  const { pathname, searchStr } = useLocation();
  const creationProgress = useCampaignCreationTasks();
  const pageOwnsScroll = pageOwnsApplicationScroll(pathname, searchStr);

  return (
    <AnimatedSidebarProvider>
      <div className="paper-app fixed inset-0 flex gap-2 overflow-hidden bg-canvas p-2 text-ink">
        <AppSidebar creationProgress={creationProgress} />
        <section className="flex min-w-0 flex-1 flex-col overflow-hidden rounded-[14px] border border-line bg-surface">
          <SiteHeader />
          <main
            className={cn(
              "paper-scrollbar flex min-h-0 flex-1 flex-col bg-surface",
              pageOwnsScroll ? "overflow-hidden" : "overflow-y-auto",
            )}
          >
            {children}
          </main>
        </section>
        <AssistantLauncher />
      </div>
    </AnimatedSidebarProvider>
  );
}
